import React, {  } from "react"
import { get } from 'lodash'
import { makeStyles } from "@material-ui/core"
import DeleteIcon from '@material-ui/icons/Delete'
import EditIcon from '@material-ui/icons/Edit'
import { CurrencyValue } from './CurrencyValue'
import { getUserStoredCountry } from '../v2_actions/auth_country'

const useStyles = makeStyles({
    missing_photograph_container: {
        border: "1px solid lightgray"
    },
    noSelectedPhotograph: {
        "&:hover": {
            outline: "2px solid #06befa"
        }
    },
    imgStyle: {
        transition: "transform .135s cubic-bezier(0.0,0.0,0.2,1),opacity linear .15s",
        height: "200px"
    },
    cont: {
        backgroundColor: "#eee",
        position: "relative",
        height: "200px"
    },
    photographIcons: {
        position: "absolute",
        top: "0px",
        left: "0px",
        zIndex:"99",
        display: "flex"
    },
    photographIcon: {
        borderRadius: "20px",
        border: "1px solid black",
        backgroundColor: "white",
        display: "flex",
        padding: "2px",
        marginLeft: "3px"
    },
    photographActions: {
        position: "absolute",
        top: "0px",
        right: "0px",
        zIndex: "99",
        display: "flex",
        borderRadius: "20px",
        border: "1px solid black",
        backgroundColor: "white",
        padding: "2px",
    },
    photographAction: {
        cursor: "pointer",
        alignItems: "center",
        display: "flex",
        padding: "2px",
        "&:hover": {
            backgroundColor: "gray",
        },
        marginLeft: "3px",
        borderRadius: "10px"
    },
    photographUnadornedAction: {
        cursor: "pointer",
        backgroundColor: "white",
        display: "flex",
        padding: "2px",
        "&:hover": {
            backgroundColor: "gray",
        },
        marginLeft: "3px"
    }
})

export const PhotoArtGalleries = ({
    photo,
    onDeletePhotoArtGallery,
    onEditPhotoArtGallery
}) => {

    const classes = useStyles()
    const country = getUserStoredCountry()
    
    const renderActions = () => {
        return (
            <div className={classes.photographActions}>
              <div className={classes.photographAction} onClick={() => onDeletePhotoArtGallery(photo)}>
                <DeleteIcon />
              </div>
              <div className={classes.photographAction} onClick={() => onEditPhotoArtGallery(photo)}>
                <EditIcon />
              </div>
              <div className={classes.photographAction}>
                <CurrencyValue value={photo.price} country={country} />
              </div>
            </div>
        )
    }
    
    return (
        <div key={photo.id} className={classes.cont}>
          { renderActions() }
          { get(photo, "gallery_size_file_info") &&
             <img src={get(photo, ["gallery_size_file_info", "download_url"])}
                  className={classes.imgStyle}/>
          }
        </div>
    )
}

